function setupAboutUsPage() {
  jQuery('.about-us .team .member').colorbox({
    inline : true,
    href: '#templates #member-overlay',
    maxWidth: '720px',
    maxHeight: '90%',
    closeButton: false,
    width: '90%',
    onLoad : function() {     
      var uuid = jQuery(this).attr('employee-uuid');
      
      jQuery('#member-overlay img').attr('src', '/img/employees/' + uuid + '-bio.jpg');
      jQuery('#member-overlay h1').html(jQuery(this).parent().parent().find('#name').html());
      jQuery('#member-overlay h3').html(jQuery(this).parent().parent().find('#title').html());
      jQuery('#member-overlay p').html(jQuery(this).find('#bio').html());
      
      jQuery.colorbox.resize();
    },
    onComplete : function() {
      jQuery.colorbox.resize();
    }
  });
}